import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import Global from '../store/global-selectors';
import { isStandardPlan, isPremiumPlan, isXMigrationPlanCode } from '../enums/billing-plan-ids';
import { usePlanMigrationModalDismissed, useUserSettingsReady } from './use-user-setting';
import { useGetPlanTrialData } from '../components/header-notification-banner/billing-plan-trial-banner/use-get-plan-trial-data';

type PlanMigrationModalState = {
  shouldShowPlanMigrationModal: boolean;
  billingPlanId: number | undefined;
  isPremiumTrial: boolean;
  closeModal: () => void;
};

export const usePlanMigrationWelcome = (): PlanMigrationModalState => {
  const subscriptionPlanInfo = useSelector(Global.selectSellerSubscriptionPlanInfo);
  const billingPlanId = subscriptionPlanInfo?.billingPlanId;
  const planCode = subscriptionPlanInfo?.planCode;
  const userSettingsReady = useUserSettingsReady();
  const modalDismissed = usePlanMigrationModalDismissed();
  const { isInPlanTrial, activeBillingPlanId } = useGetPlanTrialData();

  const [showModal, setShowModal] = useState(false);

  const isOnPremiumTrial = isInPlanTrial && isPremiumPlan(activeBillingPlanId);

  useEffect(() => {
    if (!isXMigrationPlanCode(planCode)) {
      return;
    }

    if (!userSettingsReady) {
      return;
    }

    if (modalDismissed) {
      return;
    }

    if (isStandardPlan(billingPlanId) || isPremiumPlan(billingPlanId) || isOnPremiumTrial) {
      setShowModal(true);
    }
  }, [userSettingsReady, modalDismissed, billingPlanId, planCode, isOnPremiumTrial]);

  return {
    shouldShowPlanMigrationModal: showModal,
    billingPlanId,
    isPremiumTrial: isOnPremiumTrial,
    closeModal: () => setShowModal(false),
  };
};
